import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: 8
  },
  subtitle: {
    display: 'block',
    lineHeight: 1.3,
    marginBottom: 16
  },
  // Counter row above the list — mirrors FormSectionWrapper's "TOTAL X items" (light mode)
  totalRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 8,
    marginBottom: 4
  },
  totalText: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.beige_75
  },
  totalCount: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.green_75
  },
  groupList: {
    maxHeight: 360,
    overflowY: 'auto',
    border: `1px solid ${theme.colorPalette.beige_50}`,
    borderRadius: 4,
    marginBottom: 16,
    backgroundColor: theme.colorPalette.white
  },
  groupRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 12px',
    // Zebra striping for skimability; stripes replace per-row divider borders
    '&:nth-child(even)': {
      backgroundColor: theme.colorPalette.beige_25
    }
  },
  groupDescription: {
    marginLeft: 'auto',
    textAlign: 'right',
    lineHeight: 1.2
  },
  newChip: {
    height: 20
  },
  // Label's base style is display:flex, which drops the whitespace text nodes around
  // inline elements (e.g. the reload link) — block restores normal inline text flow
  bannerText: {
    display: 'block',
    lineHeight: 1.3
  },
  // Renders the reload action as an inline text link so it flows with the banner sentence
  reloadLink: {
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    color: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  // Layout shim around the shared core Banner component: it's designed for full-width
  // page headers (50px icon + text block hard-coded to 94% width, square corners,
  // 58px min-height), which wraps the icon onto its own row at dialog width. Tighten
  // it so icon + text share one row and the card sits comfortably inside the modal.
  bannerWrapper: {
    marginBottom: 16,
    '& > div': {
      borderRadius: 4,
      minHeight: 'unset',
      padding: '10px 15px',
      boxShadow: 'none', // callouts aren't clickable — drop the Card elevation
      animation: 'none' // Banner's slide-in is for page headers; in a dialog it should pop in-situ
    },
    '& img': {
      width: 24,
      height: 24,
      marginRight: 12
    },
    '& img + div': {
      width: 'auto',
      flex: 1,
      minHeight: 'unset'
    }
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8
  }
}));

export default useStyles;
